module.exports = __webpack_public_path__ + "img/advantage2@2x.8853ac64.png";